module.exports = require('./mnemonic');



//////////////////
// WEBPACK FOOTER
// ./node_modules/bitcoincashjs/src/mnemonic/index.js
// module id = hu+u
// module chunks = 0